import { sendRequest } from "../request";
const BASE_URL = '/api/users';


export function checkToken() {
    return sendRequest(`${BASE_URL}/check-token`);
}

export function signUp(userData){
    return sendRequest(BASE_URL, "POST", userData, 'Invalid Sign Up')
}

export function checkUsername(username) {
    return sendRequest(`${BASE_URL}/checkUsername/${username}`)
}

export function checkEmail(email) {
    return sendRequest(`${BASE_URL}/checkEmail/${email}`)
}

export function login(credentials) {
    return sendRequest(`${BASE_URL}/login`, "POST", credentials, 'Invalid Credentials')
}

export function getUserData(userID) {
    return sendRequest(`${BASE_URL}/${userID}`)
}

export function updatePassword(data) {
    return sendRequest(`${BASE_URL}/${data.user._id}/updatePassword`, "PUT", data, 'Unable to Update Password')
}

export function updatePreferences(userID, data) {
    return sendRequest(`${BASE_URL}/${userID}/updatePreferences`, "PUT", data, 'Unable to Update Preferences')
}

export function updateAccountStatus(data) {
    return sendRequest(`${BASE_URL}/${data.user._id}/updateStatus`, "PUT", data, 'Unable to Update Account Status')
}

export function resetAccountPassword(data) {
    return sendRequest(`${BASE_URL}/${data.user._id}/resetPassword`, "PUT", data, 'Password Reset Failed')
}

export function updateNotification(userID, notificationID) {
    return sendRequest(`${BASE_URL}/${userID}/updateNotifications/${notificationID}`, "PUT", {}, 'Unable to Update Notification')
}

export function getAllUsers() {
    return sendRequest(`${BASE_URL}/allUsers`)
}

export function getAllUsersBasic() {
    return sendRequest(`${BASE_URL}/allUsersBasic`)
}

export function deleteUser(userItem) {
    return sendRequest(`${BASE_URL}/deleteUser`,"DELETE", userItem,'Unable to delete')
}
